import React from 'react';
import { Shield, Search } from 'lucide-react';
export function SecurityAndInvestigationsSection() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-445">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-446">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-447">
          {/* Left Column */}
          <div className="bg-brand-black p-8 md:p-10 border border-brand-gray-800 h-full" data-id="element-448">
            <div className="w-12 h-12 bg-brand-teal/10 border border-brand-teal/30 flex items-center justify-center mb-8" data-id="element-449">
              <Shield className="w-6 h-6 text-brand-teal" data-id="element-450" />
            </div>
            <h2 className="text-xl font-bold text-brand-white uppercase tracking-wide mb-6 leading-snug" data-id="element-451">
              Security, Investigative Services and Safety Preventive Measures
              for Business and Educational Facilities
            </h2>
            <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed" data-id="element-452">
              <p data-id="element-453">
                The most common new age threat that exists in any workplace or
                campus is the Active Shooter-Hostile Intruder. Many of the past
                history of shootings and Hostile Intruder attacks have taken
                place in a multitude of locations such as college campuses,
                airports, movie theaters, malls and large businesses.
              </p>
              <p data-id="element-454">
                We can help your business or school develop a comprehensive plan
                for assorted emergency situations while never disrupting your
                day to day operation. Our consulting firm boasts the first of
                its kind to provide training for board of education managers,
                educators, college campus environments and in addition, the
                first consulting-security manager to write the first ever Active
                Shooter Emergency Response plan for some of the biggest
                international airports in the world.
              </p>
              <p data-id="element-455">
                In addition, our highly trained professional Executive
                Protection teams are strategically placed in locations to
                immediately respond to service at a moments notice.
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="bg-brand-black p-8 md:p-12 border border-brand-gray-800 h-full" data-id="element-456">
            <div className="w-12 h-12 bg-brand-teal/10 border border-brand-teal/30 flex items-center justify-center mb-8" data-id="element-457">
              <Search className="w-6 h-6 text-brand-teal" data-id="element-458" />
            </div>
            <h2 className="text-xl font-bold text-brand-white uppercase tracking-wide mb-6 leading-snug" data-id="element-459">
              Investigations
            </h2>
            <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed" data-id="element-460">
              <p data-id="element-461">
                Our investigative services are structured to help protect your
                company, your people, and your operations no matter where you do
                business. We work with trusted investigators and consultants,
                including international resources when needed, to support
                clients with responsive, professional service across a wide
                range of situations.
              </p>
              <p data-id="element-462">
                Our capabilities include high-end surveillance, pre-protection
                client security assessments, background investigations, and
                related investigative support tailored to client needs. Each
                matter is approached with discretion, attention to detail, and a
                clear focus on helping clients strengthen security, improve
                awareness, and move forward with confidence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}